import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar2 from "./Sidebar2";
import api from "../../../utils/api";

const AdminHeader = ({
  toggleSidebar,
  isSidebarOpen,
  isMobile,
}) => {
  const [data, setData] = useState(0);
   const [username, setUsername] = useState(0);

  const [isSidebar2Open, setIsSidebar2Open] = useState(false);

  const auth = localStorage.getItem("admin");

  /* ===============================
     FETCH BALANCE
  =============================== */

  const fetchBalance = async () => {
    try {
      const response = await api.post(
        "/api/webapi/admin/listMember",
        {
          typeid: "1",
          pageno: 1,
          limit: 10,
          search: "",
          language: "vi",
        },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      const members = response?.data?.datas || [];

      const currentUser = members.find(
        (item) => item?.token === auth
      );

      if (currentUser) {
       setUsername(currentUser?.username || "")
        setData(currentUser?.money || 0);
      }
    } catch (error) {
      console.error("Balance error:", error);
    }
  };

  useEffect(() => {
    fetchBalance();
  }, []);


  /* ===============================
     FULLSCREEN
  =============================== */

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
  };


  /*
   * Sidebar widths match AdminLTE:
   *
   * Open     = 250px
   * Collapse = 73px
   * Mobile   = 0px
   */

  const getHeaderLeft = () => {
    if (isMobile) {
      return "0px";
    }

    return isSidebarOpen ? "245px" : "73px";
  };


  return (
    <>
      <header
        className="bet-header"
        style={{
          left: getHeaderLeft(),
        }}
      >

        {/* =====================================
            LEFT SECTION
        ====================================== */}

        <div className="bet-header-left">

          {/* Hamburger */}
          <button
            type="button"
            className="bet-menu-btn"
            onClick={toggleSidebar}
            aria-label="Toggle Sidebar"
          >
            <i className="fas fa-bars"></i>
          </button>


          {/* Search */}
          {/* <div className="bet-search-box">

            <input
              type="text"
              placeholder="Search User"
            />

          </div> */}


          {/* Upcoming Fixture */}
          {/* <div className="bet-fixture">

            <div className="bet-fixture-label">
              <span>Upcoming</span>
              <span>Fixtures</span>
            </div>


            <div className="bet-fixture-content">

              <div className="bet-ball">
                <i className="fas fa-basketball-ball"></i>
              </div>


              <div className="bet-match">

                <div className="bet-match-name">
                  Taiwan Blue - Strong Group Athletics
                </div>

                <div className="bet-match-date">
                  16/08/2026 16:30:00
                </div>

              </div>

            </div>

          </div> */}

        </div>


        {/* =====================================
            RIGHT SECTION
        ====================================== */}

        <div className="bet-header-right">

          {/* Fullscreen */}
          <button
            type="button"
            className="bet-icon-btn"
            onClick={handleFullscreen}
            title="Fullscreen"
          >
            <i className="fas fa-expand"></i>
          </button>


          {/* Rules */}
          <Link
            to="#"
            className="bet-rules"
            onClick={(e) => e.preventDefault()}
          >
            <i className="fas fa-info-circle"></i>
            <span>Rules</span>
          </Link>


          {/* Points */}
          <div className="bet-points">

            <span>pts:</span>

            <strong>
              {Number(data || 0).toFixed(2)}
            </strong>

          </div>


          {/* User */}
          <div
            className="bet-user"
            onClick={() =>
              setIsSidebar2Open(!isSidebar2Open)
            }
          >
{console.log(data,"data")}
            <span>{username || ""}</span>

            <i className="fas fa-chevron-down"></i>

          </div>

        </div>

      </header>


      {/* =====================================
          SIDEBAR 2
      ====================================== */}

      <Sidebar2
        isOpen={isSidebar2Open}
        toggleSidebar={() =>
          setIsSidebar2Open(!isSidebar2Open)
        }
      />


      {/* =====================================
          CSS
      ====================================== */}

      <style>{`

        /* =====================================
           RESET
        ====================================== */

        .bet-header,
        .bet-header * {
          box-sizing: border-box;
        }


        /* =====================================
           MAIN HEADER
        ====================================== */

        .bet-header {

          position: fixed;

          top: 0;
          right: 0;

          height: 55px;

          background: #078fca;

          display: flex;

          align-items: center;

          justify-content: space-between;

          z-index: 1035;

          transition:
            left 0.25s ease,
            width 0.25s ease;

          font-family:
            Arial,
            Helvetica,
            sans-serif;

          overflow: hidden;
        }


        /* =====================================
           LEFT
        ====================================== */

        .bet-header-left {

          display: flex;

          align-items: center;

          min-width: 0;

          flex: 1;

          gap: 12px;

          height: 100%;

          padding: 0 12px;
        }


        /* =====================================
           MENU
        ====================================== */

        .bet-menu-btn {

          width: 32px;

          height: 36px;

          flex-shrink: 0;

          border: 0;

          outline: 0;

          background: transparent;

          color: #fff;

          font-size: 20px;

          display: flex;

          align-items: center;

          justify-content: center;

          cursor: pointer;
        }


        .bet-menu-btn:hover {
          opacity: 0.8;
        }


        /* =====================================
           SEARCH
        ====================================== */

        .bet-search-box {

          width: clamp(
            170px,
            17vw,
            320px
          );

          min-width: 150px;

          height: 40px;

          background: #fff;

          border-radius: 7px;

          display: flex;

          align-items: center;

          flex-shrink: 1;

          border: 1px solid #d7dce0;

          overflow: hidden;
        }


        .bet-search-box input {

          width: 100%;

          height: 100%;

          border: 0;

          outline: 0;

          padding: 0 15px;

          background: transparent;

          color: #333;

          font-size: 14px;
        }


        .bet-search-box input::placeholder {

          color: #c4cbd0;

        }


        /* =====================================
           FIXTURE
        ====================================== */

        .bet-fixture {

          height: 40px;

          min-width: 230px;

          max-width: 400px;

          flex: 1;

          background: #15191c;

          border-radius: 8px;

          overflow: hidden;

          display: flex;

          align-items: stretch;

          flex-shrink: 1;

          position: relative;
        }


        /* =====================================
           FIXTURE TITLE
        ====================================== */

        .bet-fixture-label {

          width: 104px;

          min-width: 104px;

          background: #35393c;

          color: #fff;

          display: flex;

          flex-direction: column;

          justify-content: center;

          padding-left: 12px;

          font-size: 14px;

          line-height: 16px;

          font-weight: 700;

          position: relative;

          z-index: 2;
        }


        /* Triangle */

        .bet-fixture-label::after {

          content: "";

          position: absolute;

          top: 0;

          right: -22px;

          width: 0;

          height: 0;

          border-top: 23px solid transparent;

          border-bottom: 23px solid transparent;

          border-left: 22px solid #35393c;
        }


        /* =====================================
           FIXTURE CONTENT
        ====================================== */

        .bet-fixture-content {

          display: flex;

          align-items: center;

          min-width: 0;

          flex: 1;

          padding-left: 27px;

          gap: 9px;
        }


        .bet-ball {

          color: #aeb4b8;

          font-size: 17px;

          flex-shrink: 0;
        }


        .bet-match {

          min-width: 0;

          overflow: hidden;

          padding-right: 12px;
        }


        .bet-match-name {

          color: #c9cbcc;

          font-size: 15px;

          line-height: 17px;

          white-space: nowrap;

          overflow: hidden;

          text-overflow: ellipsis;
        }


        .bet-match-date {

          color: #858b8f;

          font-size: 11px;

          margin-top: 2px;

          white-space: nowrap;
        }


        /* =====================================
           RIGHT
        ====================================== */

        .bet-header-right {

          height: 100%;

          display: flex;

          align-items: center;

          gap: 14px;

          flex-shrink: 0;
        }


        /* =====================================
           FULLSCREEN
        ====================================== */

        .bet-icon-btn {

          width: 30px;

          height: 35px;

          border: 0;

          outline: 0;

          background: transparent;

          color: #4e565a;

          font-size: 17px;

          display: flex;

          align-items: center;

          justify-content: center;

          cursor: pointer;
        }


        .bet-icon-btn:hover {

          color: #fff;

        }


        /* =====================================
           RULES
        ====================================== */

        .bet-rules {

          display: flex;

          align-items: center;

          gap: 5px;

          color: #ffae00;

          font-size: 12px;

          font-weight: 700;

          text-decoration: underline;

          white-space: nowrap;
        }


        .bet-rules i {

          color: #4f575b;

          font-size: 15px;
        }


        /* =====================================
           POINTS
        ====================================== */

        .bet-points {

          display: flex;

          align-items: center;

          gap: 4px;

          color: #fff;

          font-size: 15px;

          white-space: nowrap;
        }


        .bet-points strong {

          font-size: 16px;

          font-weight: 700;
        }


        /* =====================================
           USER
        ====================================== */

        .bet-user {

          height: 70px;

          min-width: 90px;

          padding: 0 16px;

          // background: #dfe4e5;

          color: #fff;

          display: flex;

          align-items: center;

          justify-content: center;

          gap: 7px;

          font-size: 15px;

          cursor: pointer;

          white-space: nowrap;
          font-weight:500;
        }


        .bet-user:hover {

          background: #d6dcdd;

        }


        .bet-user i {

          font-size: 10px;

        }


        /* =====================================
           LARGE DESKTOP
        ====================================== */

        @media (min-width: 1600px) {

          .bet-search-box {

            width: 330px;

          }

          .bet-fixture {

            max-width: 610px;

          }

          .bet-match-name {

            font-size: 15px;

          }

        }


        /* =====================================
           1400px
        ====================================== */

        @media (max-width: 1400px) {

          .bet-header-left {

            gap: 9px;

          }

          .bet-fixture {

            max-width: 450px;

          }

          .bet-header-right {

            gap: 10px;

          }

          .bet-user {

            min-width: 140px;

          }

        }


        /* =====================================
           1200px
        ====================================== */

        @media (max-width: 1200px) {

          .bet-search-box {

            width: 190px;

          }

          .bet-fixture {

            max-width: 350px;

          }

          .bet-fixture-label {

            width: 90px;

            min-width: 90px;

            font-size: 12px;

          }

          .bet-fixture-label::after {

            right: -19px;

            border-left-width: 19px;

          }

          .bet-fixture-content {

            padding-left: 23px;

          }

          .bet-match-name {

            font-size: 13px;

          }

          .bet-rules span {

            display: none;

          }

          .bet-points {

            font-size: 13px;

          }

          .bet-points strong {

            font-size: 14px;

          }

          .bet-user {

            min-width: 125px;

            font-size: 13px;

          }

        }


        /* =====================================
           992px
        ====================================== */

        @media (max-width: 992px) {

          .bet-search-box {

            width: 170px;

          }

          .bet-fixture {

            max-width: 300px;

          }

          .bet-fixture-label {

            width: 80px;

            min-width: 80px;

          }

          .bet-fixture-content {

            padding-left: 18px;

          }

          .bet-match-name {

            font-size: 12px;

          }

          .bet-match-date {

            font-size: 10px;

          }

          .bet-header-right {

            gap: 6px;

          }

          .bet-user {

            min-width: 105px;

            padding: 0 10px;

          }

        }


        /* =====================================
           MOBILE / TABLET
        ====================================== */

        @media (max-width: 768px) {

          .bet-header {

            left: 0 !important;

            height: 100px;

            flex-direction: column;

            align-items: stretch;

            overflow: visible;

            padding: 6px 8px;

          }


          /* Top row */

          .bet-header-left {

            height: 42px;

            width: 100%;

            padding: 0;

            gap: 8px;

          }


          .bet-menu-btn {

            width: 30px;

            font-size: 18px;

          }


          .bet-search-box {

            width: 100%;

            height: 36px;

            min-width: 0;

          }


          .bet-fixture {

            display: none;

          }


          /* Bottom row */

          .bet-header-right {

            width: 100%;

            height: 42px;

            justify-content: flex-end;

            gap: 9px;

          }


          .bet-icon-btn {

            width: 27px;

            font-size: 15px;

          }


          .bet-rules {

            font-size: 13px;

          }


          .bet-rules i {

            font-size: 13px;

          }


          .bet-rules span {

            display: inline;

          }


          .bet-points {

            font-size: 12px;

          }


          .bet-points strong {

            font-size: 13px;

          }


          .bet-user {

            height: 34px;

            min-width: 105px;

            font-size: 12px;

            border-radius: 4px;

          }

        }


        /* =====================================
           SMALL MOBILE
        ====================================== */

        @media (max-width: 480px) {

          .bet-header {

            height: 96px;

          }


          .bet-header-right {

            gap: 5px;

          }


          .bet-rules {

            font-size: 11px;

          }


          .bet-rules i {

            font-size: 12px;

          }


          .bet-points {

            font-size: 10px;

          }


          .bet-points strong {

            font-size: 11px;

          }


          .bet-user {

            min-width: 90px;

            font-size: 10px;

            padding: 0 7px;

          }

        }

      `}</style>
    </>
  );
};

export default AdminHeader;